var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","loading":_vm.loading},on:{"click":function($event){return _vm.handleRemove()}}},[_c('v-icon',{staticClass:"red--text fa fa-trash",attrs:{"small":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }